import { Core, Maintemplate } from './bundle.js';

window.ThiemeCore = new Core();
window.ThiemeMaintemplate = new Maintemplate();

